import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/vcicon.svg'
import _imports_1 from '@/assets/icons/addonicon.svg'
import _imports_2 from '@/assets/icons/warnerror.svg'
import _imports_3 from '@/assets/icons/mailsent.svg'


const _hoisted_1 = {
  key: 0,
  class: "modal-title",
  id: "assignaddontitle"
}
const _hoisted_2 = {
  key: 1,
  class: "modalbody"
}
const _hoisted_3 = { class: "datadiv bottommargin" }
const _hoisted_4 = {
  key: 0,
  class: "selected-users-div"
}
const _hoisted_5 = {
  class: "font-regular-18",
  "data-cy": "selected-users-label"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "headerfont" }, " Available products ", -1)
const _hoisted_7 = {
  class: "overflowdiv topmargin",
  "data-cy": "products-table"
}
const _hoisted_8 = { class: "prodnamediv" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "cellimage",
  alt: "vciconimg",
  title: "vciconimg"
}, null, -1)
const _hoisted_10 = { style: {"text-align":"start"} }
const _hoisted_11 = {
  class: "font-bold",
  style: {"font-size":"14px","line-height":"19.07px"}
}
const _hoisted_12 = {
  key: 1,
  class: "headerfont topmargin"
}
const _hoisted_13 = {
  key: 2,
  class: "overflowdiv topmargin",
  "data-cy": "addons-table"
}
const _hoisted_14 = { class: "prodnamediv" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "cellimage",
  alt: "addoniconimg",
  title: "addoniconimg"
}, null, -1)
const _hoisted_16 = { style: {"text-align":"start"} }
const _hoisted_17 = {
  class: "font-bold",
  style: {"font-size":"14px","line-height":"19.07px"}
}
const _hoisted_18 = {
  key: 1,
  class: "prodnamediv"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "cellimage",
  alt: "addoniconimg",
  title: "addoniconimg"
}, null, -1)
const _hoisted_20 = { style: {"text-align":"start"} }
const _hoisted_21 = {
  class: "font-bold",
  style: {"font-size":"14px","line-height":"19.07px"}
}
const _hoisted_22 = { class: "buttonsdiv" }
const _hoisted_23 = {
  key: 3,
  class: "modalbody"
}
const _hoisted_24 = {
  key: 0,
  style: {"display":"flex"},
  class: "maxitems"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "cellimage",
  style: {"margin-top":"10px"},
  alt: "erroriconimg",
  title: "erroriconimg"
}, null, -1)
const _hoisted_26 = {
  key: 0,
  class: "errordiv",
  style: {"padding":"1rem 0"}
}
const _hoisted_27 = { class: "buttonsdiv" }
const _hoisted_28 = {
  key: 0,
  class: "fa fa-refresh fa-spin"
}
const _hoisted_29 = {
  key: 4,
  class: "modalbody"
}
const _hoisted_30 = { class: "buttonsdiv" }
const _hoisted_31 = {
  key: 5,
  class: "modalbody"
}
const _hoisted_32 = { class: "innerModal" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  style: {"width":"70px","margin-bottom":"1rem"},
  alt: "mailsenticonimg",
  title: "mailsenticonimg"
}, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "labelbld" }, "Notification email sent to: ", -1)
const _hoisted_35 = { class: "font-regular-16 btm-1" }
const _hoisted_36 = { class: "userlistdiv" }
const _hoisted_37 = {
  key: 0,
  class: "font-regular-16 breaking-words"
}
const _hoisted_38 = {
  key: 1,
  class: "font-regular-16 breaking-words"
}
const _hoisted_39 = { class: "buttonsdiv" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_AssignAddonUsersModal = _resolveComponent("AssignAddonUsersModal")!
  const _component_AddonSummaryModal = _resolveComponent("AddonSummaryModal")!
  const _component_AssignAddonsResultModal = _resolveComponent("AssignAddonsResultModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (
      _ctx.taskType === 'assignmultiaddons' ||
      _ctx.taskType === 'assignaddonexclusive' ||
      _ctx.taskType === 'assignaddonexclusiveusers' ||
      _ctx.taskType === 'summary' ||
      _ctx.taskType === 'assignaddonexclusivesummary' ||
      _ctx.taskType === 'addonExclusiveEmailSent' ||
      _ctx.taskType === 'emailSent'
    )
      ? (_openBlock(), _createElementBlock("h4", _hoisted_1, " ASSIGN ADD-ON "))
      : _createCommentVNode("", true),
    (
      _ctx.taskType === 'assignmultiaddons' || _ctx.taskType === 'assignaddonexclusive'
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.taskType === 'assignmultiaddons')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("label", _hoisted_5, "Selected users ( " + _toDisplayString(_ctx.usersSelectedCount) + " )", 1)
                ]))
              : _createCommentVNode("", true),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                id: "prodtoassigntable",
                data: _ctx.products,
                border: true,
                style: {"width":"100%"},
                "row-style": _ctx.rowdatastyle,
                "highlight-current-row": "",
                onCurrentChange: _ctx.handleCurrentChange,
                "show-header": false,
                "empty-text": "No assignable products available"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, { "min-width": "230" }, {
                    default: _withCtx((props) => [
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("h6", _hoisted_11, _toDisplayString(props.row.productName), 1),
                          _createElementVNode("label", null, " Version: " + _toDisplayString(props.row.majorVersionNumber) + "." + _toDisplayString(props.row.minorVersionNumber), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data", "row-style", "onCurrentChange"])), [
                [_directive_loading, _ctx.loading]
              ])
            ]),
            (_ctx.productSelected)
              ? (_openBlock(), _createElementBlock("label", _hoisted_12, " Select available add-on "))
              : _createCommentVNode("", true),
            (_ctx.productSelected)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    id: "prodtoassigntable",
                    ref: "multipleTableRef",
                    data: _ctx.addons,
                    border: true,
                    style: {"width":"100%"},
                    "row-style": _ctx.rowdatastyle,
                    "row-class-name": _ctx.tableRowClassName,
                    "cell-class-name": _ctx.disableCellWithSeatsUsed,
                    onSelectionChange: _ctx.handleSelectedAddOns,
                    "show-header": false,
                    "empty-text": "No assignable add-ons available"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        type: "selection",
                        width: "50"
                      }),
                      _createVNode(_component_el_table_column, { "min-width": "230" }, {
                        default: _withCtx((props) => [
                          (
                  _ctx.usersSelectedCount > props.row.seats - props.row.seatsUsed
                )
                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                key: 0,
                                placement: "top"
                              }, {
                                content: _withCtx(() => [
                                  _createTextVNode("The add-on has less seats than the selected users ")
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_14, [
                                    _hoisted_15,
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("h6", _hoisted_17, _toDisplayString(props.row.productName), 1),
                                      _createElementVNode("label", null, " Version: " + _toDisplayString(props.row.majorVersionNumber) + "." + _toDisplayString(props.row.minorVersionNumber), 1)
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (
                  _ctx.usersSelectedCount <= props.row.seats - props.row.seatsUsed
                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _hoisted_19,
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("h6", _hoisted_21, _toDisplayString(props.row.productName), 1),
                                  _createElementVNode("label", null, " Version: " + _toDisplayString(props.row.majorVersionNumber) + "." + _toDisplayString(props.row.minorVersionNumber), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, null, {
                        default: _withCtx((props) => [
                          _createElementVNode("div", {
                            class: _normalizeClass(
                  _ctx.usersSelectedCount > props.row.seats - props.row.seatsUsed
                    ? 'less-seats-label'
                    : 'font-bold-16'
                )
                          }, _toDisplayString(props.row.seatsUsed) + "/" + _toDisplayString(props.row.seats), 3)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data", "row-style", "row-class-name", "cell-class-name", "onSelectionChange"])), [
                    [_directive_loading, _ctx.addonLoading]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_el_button, {
              id: "assignaddonnext",
              round: "",
              class: "btnstyle ml-4",
              variant: "warning",
              onClick: _ctx.nextHandler,
              disabled: !_ctx.showNext,
              "data-cy": "addons-button-next"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Next ")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_el_button, {
              id: "prodassigncancel",
              round: "",
              variant: "outline-dark",
              onClick: _ctx.cancelInvite,
              class: "cancelbtn",
              "data-cy": "addons-button-cancel"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.taskType === 'assignaddonexclusiveusers')
      ? (_openBlock(), _createBlock(_component_AssignAddonUsersModal, {
          key: 2,
          selectedAddOns: _ctx.selectedAddons
        }, null, 8, ["selectedAddOns"]))
      : _createCommentVNode("", true),
    (_ctx.taskType === 'summary' || _ctx.taskType === 'assignaddonexclusivesummary')
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createVNode(_component_AddonSummaryModal, {
            assignedProduct: _ctx.selectedProduct,
            dataof: "product",
            selectedAddonList: _ctx.selectedAddons
          }, null, 8, ["assignedProduct", "selectedAddonList"]),
          (_ctx.showError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _hoisted_25,
                (_ctx.addUserError !== '')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_26, _toDisplayString(_ctx.addUserError), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_el_button, {
              round: "",
              class: "btnstyle ml-4",
              variant: "warning",
              id: "prodassingconfirm",
              onClick: _ctx.sendInvite,
              disabled: !_ctx.enableControls,
              "data-cy": "addons-button-next"
            }, {
              default: _withCtx(() => [
                (!_ctx.enableControls)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_28))
                  : _createCommentVNode("", true),
                _createTextVNode(" Confirm ")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_el_button, {
              round: "",
              class: "btnstyle ml-4",
              variant: "warning",
              id: "backbutton",
              onClick: _ctx.backClickHandler,
              "data-cy": "addons-button-back"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Back ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              id: "prodassigncancel",
              round: "",
              variant: "outline-dark",
              onClick: _ctx.cancelInvite,
              class: "cancelbtn",
              "data-cy": "addons-button-cancel"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      : _createCommentVNode("", true),
    (_ctx.taskType == 'addonExclusiveEmailSent')
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createVNode(_component_AssignAddonsResultModal, {
            selectedAddons: _ctx.selectedAddons,
            assignAddonsResult: _ctx.assignAddonResult
          }, null, 8, ["selectedAddons", "assignAddonsResult"]),
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_el_button, {
              id: "prodassigncancel",
              round: "",
              variant: "outline-dark",
              onClick: _ctx.cancelInvite,
              class: "btnstyle",
              "data-cy": "addons-button-cancel"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Done")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.taskType === 'emailSent')
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _hoisted_34,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedAddons, (addon, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "addonlistdiv"
              }, [
                _createElementVNode("label", _hoisted_35, [
                  _createTextVNode(" Add-on \""),
                  _createElementVNode("strong", null, _toDisplayString(addon.productName), 1),
                  _createTextVNode("\" has been assigned and notification email sent to users ")
                ]),
                _createElementVNode("div", _hoisted_36, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUsers, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      (item.userName)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_37, _toDisplayString(item.userName) + ", " + _toDisplayString(item.email), 1))
                        : (_openBlock(), _createElementBlock("label", _hoisted_38, _toDisplayString(item.firstName) + ", " + _toDisplayString(item.lastName) + ", " + _toDisplayString(item.email), 1))
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_el_button, {
              id: "prodassigndone",
              round: "",
              class: "btnstyle",
              variant: "warning",
              onClick: _ctx.cancelInvite,
              style: {"float":"right"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Done")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}